import styled from "styled-components";
import backgroundMobile from './images/background_mobile.jpg';
import backgroundDesktop from './images/background_desktop.jpg';

export const MainWrapper = styled.div`
  background-color: #fff;
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const VideoBackground = styled.video`
    position: absolute;
    right: 0;
    top: 0;
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    height: auto;
    background-size: cover;
    object-fit: cover;
  @media (max-width: 1400px){
    
  }
  @media (max-width: 991px){
    display: none;
  }
`;

export const PictureBackground = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    min-width: 100%;
    width: 100%;
    height: 100%;
    background-size: cover;
    object-fit: cover;
    background-color: #fff;
    background-size: cover;
    background-position: center bottom;
    background-image: url(${backgroundDesktop});
    background-repeat: no-repeat;
    @media (max-width: 991px){
      background-image: none;
      background-position: bottom center;
      background-image: url(${backgroundMobile});
    }
`;


export const VideoBackgroundMobile = styled.div`
  position: absolute;
  background-size: cover;
  background-position: center top;
  background-color: #fff;
  background-image: url(${backgroundMobile});
  background-repeat: no-repeat;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
    height: auto;
  min-width: 100%;
    min-height: 100%;
  object-fit: cover;
  @media (min-width: 992px){
    display: none;
  }
`;

